import React, { useRef, useEffect } from 'react';
import useStyles from './style';
import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import Typography from '@material-ui/core/Typography';
import TableRow from '@material-ui/core/TableRow';
import { Paper } from "@material-ui/core";

const UploadViewer = (props) => {
  const { block, appId, orgId, currentOpportunityId, blockState, setBlockState, isEditable } = props;
  const { chartUniqueId } = props.data;
  const {
    formData: { document }
  } = props;

  const classes = useStyles();
  const fileInputRef = useRef(null);

  const handleButtonClick = () => fileInputRef.current?.click();

  const hasOpportunityId = props?.match?.params?.id


  const handleFileChange = (event) => {
    const file = event.target.files?.[0];
    if (props.match?.params?.id && props.onEditModeChange) {
      props.onEditModeChange(true);
    }
    if (file) {
      if (hasOpportunityId) {
        props.uploadAttachmentOpportunity(payloadForUploadSupportingDocument(file));
      } else {
        storeFileInFormState(file);
      }
    }
  };

  const storeFileInFormState = (file) => {
    const fileData = {
      id: `local_${Date.now()}_${Math.random()}`,
      fileName: file.name,
      originalName: file.name,
      file: file,
      isLocal: true,
      // dataModelId: block.mainDataModel,
      // subDataModelId: block.dataModel,
      dataModelId: block.mainDataModel,
      subDataModelId: block.dataModel,
      size: file.size,
      type: file.type,
      lastModified: file.lastModified
    };

    const currentFiles = blockState[`uploadedFiles`] || []; // ✅ Get existing files
    const updatedFiles = [...currentFiles, fileData]; // ✅ Add new file to existing array

    setBlockState({
      ...blockState,
      [`uploadedFiles`]: updatedFiles
    });

    // Clear the file input
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  useEffect(() => {
    if (hasOpportunityId) {
      const payload = {
        appId,
        orgId,
        dataModelId: block.mainDataModel,
        subDataModelId: block.dataModel,
        opportunityId: currentOpportunityId,
        dataUniqueId: `${chartUniqueId}_uploaded_lists_file`
      };
      props.getAllActionsOfOpportunity(payload);
    }
  }, [
    document[`${chartUniqueId}_upload_attachments_opp`],
    document[`${chartUniqueId}_delete_attachments_file`]
  ]);

  const payloadForUploadSupportingDocument = (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return {
      formData,
      appId: props.match.params.appid,
      // dataModelId: block.mainDataModel,
      // subDataModelId: block.dataModel,
      dataModelId: block.dataModel,
      subDataModelId: block.mainDataModel,
      opportunityId: props?.match?.params?.id || currentOpportunityId,
      dataUniqueId: `${chartUniqueId}_upload_attachments_opp`,
    };
  };

  const getColumns = () => {
    const cols = [];
    if (block?.config?.[0]?.TableDataElements) {
      block.config[0].TableDataElements.forEach(col => cols.push(col.label));
    } else {
      cols.push('File Name');
    }
    if (block?.config?.[0]?.actions?.enable && isEditable) cols.push('Action');
    return cols;
  };

  const removeFileFromFormState = (fileId) => {
    const currentFiles = blockState[`uploadedFiles`] || [];
    const updatedFiles = currentFiles.filter(file => file.id !== fileId);
    
    setBlockState({
      ...blockState,
      [`uploadedFiles`]: updatedFiles
    });
  };

  const getActionConfig = () =>
    block?.config?.[0]?.actions || { enable: false, delete: false, download: false };

  const handleDeleteUploaded = (e, item) => {
    e.preventDefault();
    if (item.isLocal) {
      removeFileFromFormState(item.id);
    }
    else {
      const idsArray = [item['_id']];
      const result = { ids: idsArray };
      const payload = {
        appId,
        orgId,
        dataModelId: block.dataModel,
        subDataModelId: block.mainDataModel,
        opportunityId: props?.match?.params?.id || currentOpportunityId,
        data: result,
        dataUniqueId: `${chartUniqueId}_delete_attachments_file`
      };
      if (props.match?.params?.id && props.onEditModeChange) {
        props.onEditModeChange(true);
      }
      props.deleteAttachmentsForOpportunity(payload);
    }
  };

  const handleDownload = (e, item) => {
    e.preventDefault();
    console.log('item**', item)
    props.downloadContractPDFAction({
      appid: appId,
      isDownload: true,
      openFile: false,
      pdfLoadRefresh: false,
      noType: true,
      dataModelId: block.dataModel,
      field: 'path',
      modelDataType: 'attachments',
      "_id": item['_id'],
      dataUniqueId: "quickView_Attachments_download"
  });
  }

  const renderFileActions = (row) => {
    const actionConfig = getActionConfig();
    if (!actionConfig.enable || !isEditable) return null;

    return (
      <div className={classes.actionBtns}>
        {actionConfig.download && !row.isLocal && (
          <img
            src="/media/createStepper/arrowButtonNew.svg"
            alt="download"
            className={classes.actionIcon}
            onClick={(e) => {
              e.preventDefault();
              handleDownload(e, row);
              // implement download if needed
            }}
          />
        )}
        {actionConfig.delete && (
          <img
            src="/media/createStepper/deleteContracts.svg"
            alt="delete"
            className={classes.actionIcon}
            onClick={(e) => handleDeleteUploaded(e, row)}
          />
        )}
      </div>
    );
  };

  const columns = getColumns();
  const actionEnabled = getActionConfig().enable && isEditable;
  const dataLoading =
    props.formData[`${chartUniqueId}_uploaded_lists_file_loading`] ||
    props.formData[`${chartUniqueId}_delete_attachments_file_loading`] ||
    props.formData[`${chartUniqueId}_upload_attachments_opp_loading`];

  const getAllFiles = () => {
    if (hasOpportunityId) {
      // Get files from server when opportunity ID exists
      const list = document[`${chartUniqueId}_uploaded_lists_file`];
      if (Array.isArray(list) && list.length > 0) {
        return list.map((file, index) => ({
          ...file,
          id: file._id || file.id || index,
          isLocal: false
        }));
      }
    } else {
      // Get files from form state when no opportunity ID
      const localFiles = blockState[`uploadedFiles`] || [];
      return localFiles.map((file, index) => ({
        ...file,
        id: file.id || index,
        isLocal: true
      }));
    }
    return [];
  };

  const allFiles = getAllFiles();
  const colsToRender = actionEnabled ? columns.slice(0, -1) : columns;

  return (
    <div>
      {/* Banner */}
      <div className={classes.sectionPadding}>
        <div className={classes.banner}>
          <img
            src="/media/createStepper/contractImages.svg"
            className={classes.bannerImg}
            alt=""
          />
          <div className={classes.bannerRow}>
            <Button
              variant="contained"
              className={classes.bannerBtn}
              onClick={handleButtonClick}
              disabled={!isEditable}
              style={{ backgroundColor: isEditable ? '' : 'transparent', cursor: isEditable ? 'pointer' : 'not-allowed' }}
              disableElevation
            >
              {block.buttonText}
            </Button>
            <input
              type="file"
              ref={fileInputRef}
              onChange={handleFileChange}
              style={{ display: 'none' }}
              accept="*/*"
            />
            <div className={classes.bannerTextWrap}>
              <Typography className={classes.bannerSubHeading}>
                {block.subHeading}
              </Typography>
              <Typography className={classes.bannerTopHeading}>
                {block.topHeading}
              </Typography>
            </div>
          </div>
        </div>
      </div>

      {/* Table / Empty State */}
      {dataLoading ? (
        props.loader
      ) : allFiles.length > 0 ? (
        <div className={classes.tableSection}>
          <TableContainer component={Paper} className={classes.tableContainer}>
            <Table className={classes.table} aria-label="attachments table">
              <TableHead className={classes.tableHead}>
                <TableRow>
                  {columns.map((col, index) => {
                    const isLast = index === columns.length - 1;
                    const isAction = col === 'Action';
                    return (
                      <TableCell
                        key={index}
                        className={classes.tableHeaderCell}
                        style={{
                          borderTopLeftRadius: index === 0 ? 8 : 0,
                          borderTopRightRadius: isLast ? 8 : 0,
                          ...(isAction ? { width: 80, textAlign: 'center' } : {})
                        }}
                      >
                        {col}
                      </TableCell>
                    );
                  })}
                </TableRow>
              </TableHead>
              <TableBody>
                {allFiles.map((row, idx) => (
                  <TableRow key={row.id ?? idx}>
                    {colsToRender.map((col, i) => (
                      <TableCell key={i} className={classes.tableCell}>
                        <span className={classes.cellContent}>
                          <Typography className={classes.cellText}>
                            {row.originalName || row.fileName || '-'}
                          </Typography>
                        </span>
                      </TableCell>
                    ))}
                    {actionEnabled && (
                      <TableCell className={`${classes.tableCell} ${classes.actionCell}`}>
                        {renderFileActions(row)}
                      </TableCell>
                    )}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      ) : (
        <div className={classes.emptyWrap}>
          <Typography className={classes.emptyText}>No attachments found</Typography>
        </div>
      )}
    </div>
  );
};

export default UploadViewer;
